import React, { SVGProps } from "react";

const GlobeSettingIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask
        id="mask0_3368_2780"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="23"
      >
        <path d="M0 0.5H22V22.5H0V0.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_3368_2780)">
        <path
          d="M9.45312 21.6406V19.7801L9.31545 19.7521C8.26732 19.5393 7.27332 19.1252 6.36109 18.5212L6.24396 18.4437L4.92332 19.7644L2.73565 17.5767L4.05629 16.256L3.97878 16.1389C3.37481 15.2267 2.96068 14.2327 2.74789 13.1845L2.71992 13.0469H0.859375V9.95312H2.71992L2.74789 9.81545C2.96068 8.76732 3.37481 7.77332 3.97878 6.86109L4.05629 6.74396L2.73565 5.42332L4.92332 3.23565L6.24396 4.55629L6.36109 4.47878C7.27332 3.87481 8.26732 3.46068 9.31545 3.24789L9.45312 3.21992V1.35938H12.5469V3.21992L12.6845 3.24789C13.7327 3.46068 14.7267 3.87481 15.6389 4.47878L15.756 4.55629L17.0767 3.23565L19.2644 5.42332L17.9437 6.74396L18.0212 6.86109C18.6252 7.77332 19.0393 8.76732 19.2521 9.81545L19.2801 9.95312H21.1406V13.0469H19.2801L19.2521 13.1845C19.0393 14.2327 18.6252 15.2267 18.0212 16.1389L17.9437 16.256L19.2644 17.5767L17.0767 19.7644L15.756 18.4437L15.6389 18.5212C14.7267 19.1252 13.7327 19.5393 12.6845 19.7521L12.5469 19.7801V21.6406H9.45312Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeMiterlimit="10"
        />
        <path
          d="M16.1563 11.5C16.1563 14.3477 13.8477 16.6562 11 16.6562C8.15229 16.6562 5.84375 14.3477 5.84375 11.5C5.84375 8.65229 8.15229 6.34375 11 6.34375C13.8477 6.34375 16.1563 8.65229 16.1563 11.5Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeMiterlimit="10"
        />
        <path
          d="M12.7188 11.5C12.7188 14.3477 11.9492 16.6562 11 16.6562C10.0508 16.6562 9.28125 14.3477 9.28125 11.5C9.28125 8.65229 10.0508 6.34375 11 6.34375C11.9492 6.34375 12.7188 8.65229 12.7188 11.5Z"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeMiterlimit="10"
        />
        <path d="M5.84375 11.5H16.1563" stroke="currentColor" strokeWidth="1.2" strokeMiterlimit="10" />
      </g>
    </svg>
  );
};

export default GlobeSettingIcon;
